import {Button, Col, DatePicker, Form, Input} from "antd";
import dayjs from "dayjs";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";
import React from "react";
import AddTags from "../../../../common/tags/add-tags";
import DocumentUploader from "../../../../common/document-uploader/document-uploader";
import {Document} from "../../../../../domains/models/document/index";

interface ICertificationProps {
    employeeId: string;
    onUploadSuccess:(doc:Document)=>void;
}

const Certification = (props: ICertificationProps) => {
    return (
        <section className={"pn__employee-create__form__fixed-width certification"}>

            <Form.List name="certifications">
                {(fields, {add, remove}) => (
                    <>
                        {fields.map(({key, name, ...restField}, index) => (
                            <div key={key} className="certificationsBox">
                                <Col span={18}>
                                    <Form.Item
                                        {...restField}
                                        label="Title"
                                        name={[name, "title"]}
                                    >
                                        <Input placeholder="Enter title"/>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        label="University/Institute"
                                        name={[name, "university"]}
                                    >
                                        <Input placeholder="Enter university/institute"/>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        label="Certified By"
                                        name={[name, "certifiedBy"]}
                                    >
                                        <Input placeholder="Enter certified by"/>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        label="Certified On"
                                        name={[name, "certifiedOn"]}
                                    >
                                        <DatePicker
                                            style={{width: "100%"}}
                                            format="YYYY-MM-DD"
                                            disabledDate={(current) => current && current.isAfter(dayjs())}
                                        />
                                    </Form.Item>

                                    <Form.Item {...restField} label="Skills" name={[name, "skills"]}>
                                        <AddTags tagLabel={'Add Skills'}/>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, "documentId"]}
                                        label={"Upload Document"}
                                        style={{marginBottom: 'unset'}}
                                    >
                                        <DocumentUploader
                                            disabled={false}
                                            docType='CERTIFICATE'
                                            purpose='EMPLOYMENT'
                                            employeeId={props.employeeId}
                                            onUploadSuccess={props.onUploadSuccess}
                                        />
                                    </Form.Item>

                                    <div className={"removeAndResetInCertifications"}>
                                        {/*<Button onClick={handleResetFields}>Reset</Button>*/}
                                        {fields.length > 1 && (
                                            <Button danger onClick={() => remove(name)} className="remove-button">
                                                <DeleteOutlined/> Remove
                                            </Button>
                                        )}
                                    </div>
                                </Col>
                            </div>
                        ))}

                        <div className={"employee-create__actions add-btn"}>
                            <Button
                                type="primary"
                                shape={'round'}
                                icon={<PlusOutlined/>}
                                onClick={() => add()}
                            >
                                Add new certificate
                            </Button>
                        </div>
                    </>
                )}
            </Form.List>
        </section>
    )
}

export default Certification;
